import React, { memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
//
import { TextBlockWithTitle } from 'components';
import CheckInCircleIcon from 'components/SvgIcons/ComplexIcons/check-in-circle.svg';
import GeneralDocumentIcon from 'components/SvgIcons/ComplexIcons/general-document-icon.svg';
import { applicationStatusesData } from 'config/data-lists/applications-status';
import {
  applicationDocumentsList,
  sponsorDocumentsList,
} from 'config/data-lists/plannedNumberOfSitesList';

import './index.scss';

const DocumentApplicationSenderRole = Object.freeze({
  ResearchSite: 1,
  Sponsor: 2,
  Administrator: 3,
});

const titlesDocuments = {
  [DocumentApplicationSenderRole.ResearchSite]:
    'List of Site documents has been changed',
  [DocumentApplicationSenderRole.Sponsor]:
    'List of Sponsor documents has been changed',
};

export const HistoryItem = ({ item }) => {
  const {
    newStatus = 1,
    updateDate,
    senderRole,
    uploadedFiles = [],
    updatedFiles = [],
    deletedFiles = [],
    fullName,
    researchSiteNName,
    isPhysicianSponsor,
    isPersonnel,
    sponsorName,
    modifiedRole,
    personWhoChangedDocuments,
    researchSiteName,
    historyType = 1,
  } = item;

  const getFromLine = (
    isPhysicianSponsorFlag,
    roleValue,
    siteName,
    sponsorNameValue,
  ) => {
    if (
      roleValue === DocumentApplicationSenderRole.Administrator ||
      isPhysicianSponsorFlag ||
      !(sponsorNameValue || researchSiteNName)
    ) {
      return '';
    }

    return `from ${
      roleValue === DocumentApplicationSenderRole.ResearchSite
        ? siteName
        : sponsorNameValue
    }`;
  };

  const historyItemBody = () => {
    switch (historyType) {
      case 1:
        return (
          <div className={`fs-12 color-gray-dark mt-6 mb-6`}>
            <span className="color-persian-red semi-bold">{fullName} </span>
            {getFromLine(
              isPersonnel,
              isPhysicianSponsor,
              modifiedRole,
              researchSiteNName,
              sponsorName,
            )}
            {` ${statusText}`}
          </div>
        );
      case 2:
        return (
          <div className={`fs-12 color-gray-dark mt-6 mb-6`}>
            <span className="color-persian-red semi-bold">
              {personWhoChangedDocuments}{' '}
            </span>
            {getFromLine(
              isPersonnel,
              isPhysicianSponsor,
              senderRole,
              researchSiteName,
              sponsorName,
            )}
            {' has changed the following list of documents:'}
            <div className="status-data__subtitle mt-5">
              {updatedFiles.length > 0 && (
                <div>
                  <span className="color-gray fs-12">Updated document(s):</span>
                  {updatedFiles.map((item, index) => (
                    <div className="history-item-doc-gap mt-2 mb-2" key={index}>
                      <GeneralDocumentIcon />
                      {
                        applicationDocumentsList.find(
                          (doc) =>
                            doc.name.toLowerCase() === item.toLowerCase(),
                        )?.title
                      }
                      {
                        sponsorDocumentsList.find(
                          (doc) =>
                            doc.name.toLowerCase() === item.toLowerCase(),
                        )?.fieldTitle
                      }
                    </div>
                  ))}
                </div>
              )}
              {uploadedFiles.length > 0 && (
                <div>
                  <span className="color-gray fs-12">
                    Uploaded document(s):
                  </span>
                  {uploadedFiles.map((item, index) => (
                    <div className="history-item-doc-gap mt-2 mb-2" key={index}>
                      <GeneralDocumentIcon />
                      {
                        applicationDocumentsList.find(
                          (doc) =>
                            doc.name.toLowerCase() === item.toLowerCase(),
                        )?.title
                      }
                      {
                        sponsorDocumentsList.find(
                          (doc) =>
                            doc.name.toLowerCase() === item.toLowerCase(),
                        )?.fieldTitle
                      }
                    </div>
                  ))}
                </div>
              )}
              {deletedFiles.length > 0 && (
                <div>
                  <span className="color-gray fs-12">Deleted document(s):</span>
                  {deletedFiles.map((item, index) => (
                    <div className="history-item-doc-gap mt-2 mb-2" key={index}>
                      <GeneralDocumentIcon />
                      {
                        applicationDocumentsList.find(
                          (doc) =>
                            doc.name.toLowerCase() === item.toLowerCase(),
                        )?.title
                      }
                      {
                        sponsorDocumentsList.find(
                          (doc) =>
                            doc.name.toLowerCase() === item.toLowerCase(),
                        )?.fieldTitle
                      }
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const applicationStatusesIndex = newStatus - 1;
  const statusName = applicationStatusesData[applicationStatusesIndex].title;
  const statusText =
    applicationStatusesData[applicationStatusesIndex].historyBodyText;
  const historyTitle =
    historyType === 1
      ? `Application Status is ${statusName}`
      : titlesDocuments[senderRole];
  const currentDay = moment(new Date()).format('YYYY-MM-DD');

  return (
    <TextBlockWithTitle
      text={
        <div className="history_status_block mt-2">
          <div className="flex justify-content-space-between ">
            <div className="flex align-items-center form-fields__title">
              {statusName === 'Approved' && (
                <CheckInCircleIcon className="mr-2" width={17} height={17} />
              )}
              {historyTitle}
            </div>
            <div className="fs-12" style={{ color: '#8A929B' }}>
              {moment(updateDate).format('YYYY-MM-DD') === currentDay
                ? `Today, ${moment(updateDate).format('hh:mmA')}`
                : moment(updateDate).format('DD MMMM YYYY, hh:mmA')}
            </div>
          </div>
          {historyItemBody()}
        </div>
      }
    />
  );
};

HistoryItem.propTypes = {
  item: PropTypes.object,
  sponsorStatus: PropTypes.number,
};

export default memo(HistoryItem);
